import React from 'react';
import { useTranslation } from 'react-i18next';
import './PointsOfInterest.css';
import caboDePalosImage from '../cabo_de_palos.png';

const pointsOfInterestData = {
    miradores: [
        { name: 'Mirador del Galúa / Plaza del Mar' },
        { name: 'Mirador del Monte Blanco' },
        { name: 'Mirador Gola del Estacio' },
    ],
    puertos: [
        { name: 'Puerto deportivo de Cabo de Palos' },
        { name: 'Puerto deportivo Dos Mares' },
        { name: 'Puerto deportivo de La Isleta' },
        { name: 'Puerto deportivo Tomás Maestre' },
    ],
    faro: {
        name: 'Faro de Cabo de Palos',
        link: 'https://visitaelfaro.com/',
    },
    playas: [
        { name: 'Playa de Levante' },
        { name: 'La Galera' },
        { name: 'Las Escalerillas' },
        { name: 'El Descargador' },
        { name: 'Cala Reona' },
        { name: 'Playa Amoladeras' },
        { name: 'Cala del Pino' },
        { name: 'Playa del Galúa' },
        { name: 'Parque Natural de Calblanque' },
    ],
};

const PointsOfInterest = () => {
    const { t } = useTranslation();

    return (
        <section id="points-of-interest">
            <h2>{t('points_of_interest')}</h2>

            <div className="point-of-interest-category">
                <div className="event-image-container">
                    <img height="500" src={caboDePalosImage} alt="Cabo de Palos" />
                </div>
                <h3>{t('faro_de_cabo_de_palos')}</h3>
                <p>
                    <a href={pointsOfInterestData.faro.link} target="_blank" rel="noopener noreferrer">
                        {t('visita_el_faro')}
                    </a>
                </p>
                <div className="poi-icon">🏖️</div>
                <h3>{t('playas')}</h3>
                <ul>
                    {pointsOfInterestData.playas.map((item, index) => (
                        <li key={index}>{item.name}</li>
                    ))}
                </ul>
            </div>

        </section>
    );
};

export default PointsOfInterest;
